import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.REACT_APP_ENCRYPTION_KEY || 'something-secure';

// Prepare key exactly as backend does
const getKey = () => {
  // Take first 32 chars and pad with zeros
  const keyStr = SECRET_KEY.slice(0, 32).padEnd(32, '0');
  // Convert to UTF-8 bytes
  return CryptoJS.enc.Utf8.parse(keyStr);
};

export const encryptData = (data: string): string => {
  try {
    // Generate random 16-byte IV
    const iv = CryptoJS.lib.WordArray.random(16);
    
    // Get properly formatted key
    const key = getKey();

    // Encrypt with AES-256-CBC
    const encrypted = CryptoJS.AES.encrypt(data, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    // Combine IV and ciphertext and encode as base64
    const combined = CryptoJS.lib.WordArray.create([
      ...iv.words,
      ...encrypted.ciphertext.words
    ]);
    
    return CryptoJS.enc.Base64.stringify(combined);
  } catch (error) {
    throw new Error('Failed to encrypt data');
  }
};

export const decryptData = (encryptedData: string): string => {
  try {
    // Decode base64
    const combined = CryptoJS.enc.Base64.parse(encryptedData);
    
    // Extract IV (first 16 bytes)
    const iv = CryptoJS.lib.WordArray.create(combined.words.slice(0, 4));
    
    // Extract ciphertext (remaining bytes)
    const ciphertext = CryptoJS.lib.WordArray.create(combined.words.slice(4));
    
    // Get properly formatted key
    const key = getKey();

    // Create CipherParams object
    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: ciphertext,
      key: key,
      iv: iv
    });

    // Decrypt
    const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    throw new Error('Failed to decrypt data');
  }
};